import Vue from 'vue'
import Vuetify, { VBtn, VApp, VCard } from 'vuetify/lib'
import { VPagination, VTextField } from 'vuetify/lib/components'

Vue.use(Vuetify)

const myCustomLightTheme = {
  dark: false,
  defaults: {
    VueCsvImport: {
      border: 'black 1px solid',
    },
  },
}

// Vue.component('v-data-table', VDataTable)
// Vue.component('v-toolbar', VToolbar)
// Vue.component('v-toolbar-title', VToolbarTitle)
// Vue.component('v-spacer', VSpacer)
// Vue.component('v-switch', VSwitch)
// Vue.component('v-chip', VChip)
Vue.component('v-app', VApp)
Vue.component('v-card', VCard)
Vue.component('v-btn', VBtn)
Vue.component('v-pagination', VPagination)
Vue.component('v-text-field', VTextField)

export default new Vuetify()
